declare namespace $ {

	type $shm_hitalama_text_embed_image__uri_shm_hitalama_text_embed_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_text_embed['uri'] >
		,
		ReturnType< $shm_hitalama_text_embed_image['uri'] >
	>
	type $shm_hitalama_text_embed_image__title_shm_hitalama_text_embed_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_text_embed['title'] >
		,
		ReturnType< $shm_hitalama_text_embed_image['title'] >
	>
	export class $shm_hitalama_text_embed extends $mol_embed_any {
		Image_view( ): $shm_hitalama_text_embed_image
	}
	
}

//# sourceMappingURL=embed.view.tree.d.ts.map